import styled from 'styled-components';
import { TypeStyleBodyNano } from '../TypeStyle';
export const Label = styled(TypeStyleBodyNano) `
  font-weight: 700;
  ${o => (o.isUppercase ? `text-transform: uppercase;` : null)}
`;
export const Highlight = styled.span `
  position: absolute;
  background-color: white;
  height: 30px;
  width: 40px;
  border-radius: 15px;
  bottom: 2px;
  ${o => o.checked && `right: 2px`}
  ${o => !o.checked && `left: 2px`}
`;
export const InvisibleRadioButton1 = styled.input.attrs({ ...{ type: 'radio' } }) `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 50%;
  appearance: none;
  margin: 0;
  cursor: pointer;
`;
export const InvisibleRadioButton2 = styled.input.attrs({ ...{ type: 'radio' } }) `
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 50%;
  appearance: none;
  margin: 0;
  cursor: pointer;
`;
export const BackgroundPill = styled.div `
  background-color: ${o => o.theme.color.deprecated.stoneLight};
  border-radius: 34px;
  position: relative;
  height: 34px;
  max-width: 80px;
  width: 80px;
  cursor: pointer;
`;
export const AriaLabel = styled.text `
  opacity: 0;
  height: 0;
  width: 0;
`;
export const Label1Container = styled.div `
  position: absolute;
  bottom: 0px;
  left: 2px;
  width: 40px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
export const Label2Container = styled.div `
  position: absolute;
  bottom: 0px;
  right: 1px;
  width: 40px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
export const InvisibleLabel = styled.label `
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: ${o => (o.isChecked ? '3' : '2')};
  cursor: pointer;
`;
//# sourceMappingURL=styles.js.map